export interface AgreementDoc {
  id: string;
  title: string;
  updatedAt: string;
  clauseCount?: number;
  sections: { heading: string; body: string }[];
}

export const AGREEMENTS: AgreementDoc[] = [
  {
    id: 'terms',
    title: '用户服务协议',
    updatedAt: '2026 年 10 月 29 日',
    sections: [
      {
        heading: '一、总则',
        body: '欢迎您使用 ForexMind AI 量化交易决策平台（以下简称"本平台"）。本协议由您（以下简称"用户"）与杭州钜睿科技有限公司（注册地：中国浙江省杭州市，以下简称"我们"）签订。请您在使用本平台前仔细阅读本协议全部条款；您在注册或登录流程中主动确认本协议后，本协议对您生效。',
      },
      {
        heading: '二、账户注册与安全',
        body: '2.1 您可通过邮箱验证码或平台支持的 Google、X、Telegram、Apple 身份登录完成注册。关联已有平台账户时，需要完成原账户控制权核验；仅凭邮箱地址相同不会自动合并账户。\n2.2 您有责任妥善保管账户信息，包括但不限于登录邮箱、验证码等。\n2.3 如发现账户被盗用或存在异常，请立即联系我们的客服团队。\n2.4 您和我们分别对各自原因造成的账户安全问题，依适用法律承担相应责任。\n2.5 您不得将账户转让、出售或以任何形式让他人使用。',
      },
      {
        heading: '三、平台服务内容',
        body: '3.1 平台运营并发布 AI 外汇策略；用户可查看策略、提交本人交易账户资料，并在审核与资格校验后授权或停止跟随。用户端不创建或配置平台 Agent。\n3.2 AI 分析与策略建议不构成投资建议。获授权账户是否执行，仍取决于服务端资格、风控和受控执行链路；信号不等于经纪商成交。\n3.3 我们有权根据业务发展需要，新增、调整或终止部分服务功能，并以公告形式通知用户。',
      },
      {
        heading: '四、风险提示与免责声明',
        body: '4.1 外汇及其他高波动金融市场存在极高风险，过往业绩不代表未来表现。\n4.2 AI 系统的决策基于历史数据和模型推断，无法保证在所有市场条件下的准确性。\n4.3 您应充分了解市场、杠杆、流动性及第三方经纪商执行风险，结合自身情况独立评估是否使用服务。\n4.4 AI 分析不构成收益承诺；信号发出不代表经纪商已经成交。\n4.5 我们对平台服务依法应承担的责任，不因本风险提示而被免除。',
      },
      {
        heading: '五、用户行为规范',
        body: '5.1 您不得利用本平台从事任何违反法律法规的活动。\n5.2 您不得对平台系统进行逆向工程、反编译或破解。\n5.3 您不得批量注册账户、使用机器人程序访问平台接口（除平台官方提供的 API 外）。\n5.4 您不得发布虚假信息、实施欺诈行为或干扰其他用户正常使用。\n5.5 对违反上述规则的行为，我们可在必要范围内采取限制措施，并依适用法律处理相关责任。',
      },
      {
        heading: '六、知识产权',
        body: '6.1 本平台所有内容，包括但不限于软件代码、界面设计、算法模型、文字、图形，均受知识产权法律保护。\n6.2 未经我们书面授权，您不得复制、传播、修改、展示或以其他方式使用上述内容。\n6.3 您通过平台提交的反馈等内容，授权我们用于平台功能改进，但我们不会公开您的个人信息。',
      },
      {
        heading: '七、服务变更与终止',
        body: '7.1 协议发生重要变化时，我们将按适用法律通知您；需要重新同意的变更，会在登录流程中请求您主动确认。\n7.2 若您不接受变更后的协议，可停止使用服务，并通过联系我们的邮箱提出账户或个人信息处理请求。\n7.3 出现欺诈、违反本协议或法律要求等情况时，我们可在必要范围内依法限制服务；对未结交易及经纪商持仓的处理仍须遵循实际执行和对账结果。',
      },
      {
        heading: '八、争议解决',
        body: '8.1 本协议适用中华人民共和国法律（不包括冲突法规则）。\n8.2 因本协议引起的争议，双方应首先通过友好协商解决。\n8.3 协商不成的，提交本平台注册地有管辖权的人民法院诉讼解决。',
      },
      {
        heading: '九、联系我们',
        body: '如您对本协议有任何疑问，请通过电子邮件联系我们：zhoudaxing31@gmail.com。\n\n感谢您选择 ForexMind。',
      },
    ],
  },
  {
    id: 'privacy',
    title: '隐私政策',
    updatedAt: '2026 年 10 月 29 日',
    sections: [
      {
        heading: '一、引言',
        body: '杭州钜睿科技有限公司（注册地：中国浙江省杭州市，以下简称"我们"）运营 ForexMind，并处理本平台相关个人信息。我们深知个人信息对您的重要性，将依法保护您的隐私权和个人信息。本隐私政策说明我们如何收集、使用、存储、共享和保护您的个人信息，以及您如何行使相关权利。请您在使用本平台前仔细阅读本政策。',
      },
      {
        heading: '二、我们收集的信息',
        body: '2.1 账户信息：您注册时提供的电子邮箱地址；使用 Google、X、Telegram 或 Apple 身份登录时，我们验证对应服务提供的账号标识，并按该服务实际返回的范围处理邮箱及邮箱验证状态，用于注册、登录和账号关联。Apple 隐藏邮箱可能是转发地址；我们不会仅凭邮箱相同合并账户，也不读取您的邮件内容。\n2.2 使用数据：您在平台上的操作行为，包括访问记录、功能使用情况和跟随授权等。\n2.3 设备信息：设备型号、操作系统版本、IP 地址、浏览器类型等技术信息。\n2.4 交易账户资料：您提交的经纪商、服务器、账号及开通所需登录凭据；托管开通与人工开通的凭据处理方式不同，以提交页面说明为准。平台还会处理与本人账户相关的持仓和执行结果。\n2.5 通讯记录：您与客服的沟通内容，用于处理服务请求。',
      },
      {
        heading: '三、信息使用目的',
        body: '3.1 提供和维护本平台服务，包括账户、跟随授权、执行状态展示及客户支持。\n3.2 验证您的身份，防止欺诈和未授权访问。\n3.3 发送与服务和安全相关的必要通知。\n3.4 处理服务运行故障及履行适用的法律义务。',
      },
      {
        heading: '四、信息存储与安全',
        body: '4.1 我们对账户、交易资料及登录凭据采取访问控制和分用途处理措施；托管开通模式下的交易账户凭据由受保护的凭据服务管理，人工开通模式下的处理方式以提交页面说明为准。\n4.2 互联网传输和存储均存在安全风险，我们会根据实际部署采取相应保护措施。\n4.3 个人信息的保留和账户注销后的处理应遵守适用法律；法定留存义务和未完结的账户或交易事项可能影响删除时间。',
      },
      {
        heading: '五、信息共享',
        body: '5.1 我们不会出售您的个人信息。\n5.2 在以下情况下，我们可能与第三方共享必要的信息：\n   · 经您明确授权同意；\n   · 与提供云计算、数据分析、客户服务的服务商共享（受严格保密约束）；\n   · 应法律法规要求、监管机构、法院或政府部门的合法要求；\n   · 为保护平台、用户或公众的合法权益所必需。\n5.3 如发生公司合并、收购，我们将确保继续保护您的信息，并提前通知您。',
      },
      {
        heading: '六、Cookie 与追踪技术',
        body: '6.1 我们使用 Cookie 和类似技术来维持您的登录状态、记住您的偏好设置。\n6.2 我们使用分析工具（如匿名化统计）了解平台使用情况。\n6.3 您可以通过浏览器设置拒绝 Cookie，但这可能影响部分功能的正常使用。',
      },
      {
        heading: '七、您的权利',
        body: '根据适用法律，您可以提出以下请求：\n7.1 查阅或复制我们处理的您的个人信息。\n7.2 更正或补充不准确、不完整的个人信息。\n7.3 在法定情形下请求删除个人信息；提出删除请求不以先注销账户为条件。\n7.4 在符合法定条件时请求转移个人信息。\n7.5 撤回以同意为基础的个人信息处理同意；撤回不影响撤回前基于同意已进行的处理。\n请发送邮件至 zhoudaxing31@gmail.com 提出请求。我们将核验身份并依法处理；法定保存期限未届满或删除在技术上暂难实现时，将依法限制相关处理并说明原因。',
      },
      {
        heading: '八、未成年人保护',
        body: '本平台不向 18 岁以下未成年人提供服务。如您未满 18 岁，请勿注册或使用本平台。如发现可能收集了未成年人信息，我们将核实并依法处理。',
      },
      {
        heading: '九、政策更新',
        body: '本政策发生重要变化时，我们将按适用法律通知您；需要重新取得同意的变更，会在登录流程中请求您主动确认。',
      },
      {
        heading: '十、联系我们',
        body: '如您对本隐私政策有任何疑问、投诉或客服请求，请发送邮件至 zhoudaxing31@gmail.com。\n\n我们致力于保护您的隐私，感谢您对 ForexMind 的信任。',
      },
    ],
  },
  {
    id: 'risk-disclosure',
    title: '风险告知书（RD-01~15）',
    updatedAt: '2026 年 10 月 21 日',
    clauseCount: 15,
    sections: [
      {
        heading: '告知主体与联系',
        body: '本风险告知书由 ForexMind 运营主体杭州钜睿科技有限公司（注册地：中国浙江省杭州市）提供。如对本告知书有疑问，请发送邮件至 zhoudaxing31@gmail.com。',
      },
      {
        heading: 'RD-01 外汇及差价合约(CFD)市场风险',
        body: '外汇、贵金属、差价合约等杠杆交易产品具有极高的市场风险。汇率、利率、大宗商品价格可能在短时间内发生剧烈波动，导致您的持仓迅速产生大幅亏损，甚至可能损失超过您投入的全部保证金。过往市场走势和本平台展示的任何历史业绩均不代表未来表现。',
      },
      {
        heading: 'RD-02 杠杆放大亏损风险',
        body: '本平台涉及的交易产品通常具有高杠杆特性。杠杆在放大潜在收益的同时，也会同等倍数放大亏损。即使是小幅度的市场价格反向波动，也可能导致您的保证金全部亏光，并产生追加保证金（Margin Call）或强制平仓（Stop Out）的风险。请务必充分了解杠杆比例与自身风险承受能力之间的关系。',
      },
      {
        heading: 'RD-03 AI 决策系统的局限性与不确定性',
        body: 'ForexMind 平台的 AI 分析与建议基于数据、算法模型和统计推断，无法预测"黑天鹅"事件、突发地缘政治冲突、央行紧急干预等不可预见的市场变化。AI 建议仅供参考，不构成收益承诺；平台信号需经资格、风控和执行链路处理，实际成交以经纪商结果为准。您应独立评估市场风险。',
      },
      {
        heading: 'RD-04 技术系统与网络风险',
        body: '本平台及您连接的第三方经纪商系统依赖于互联网、服务器、接口和各类软硬件设施。可能存在网络延迟、服务器宕机、数据传输中断、软件故障等技术风险。在这些情况下，平台可能无法及时形成信号、提交命令或收到经纪商结果；未收到结果时不能推定交易未发生或已完成。请通过经纪商核对实际账户状态，平台责任依适用法律处理。',
      },
      {
        heading: 'RD-05 流动性风险与滑点',
        body: '在市场剧烈波动、重大经济数据发布、节假日或非正常交易时段，市场流动性可能急剧下降，导致您的订单无法按预期价格成交，产生显著滑点（Slippage）。止损单（Stop Loss）在极端行情下也可能无法按设定价格执行，实际平仓价格可能远远劣于您的止损设置。',
      },
      {
        heading: 'RD-06 经纪商执行与对手方风险',
        body: '您授权跟随后，平台可在资格和风控校验通过时通过受控 EA 链路向第三方经纪商提交执行命令；实际成交由经纪商确认，本平台不参与交易撮合。第三方经纪商的执行质量、资金安全和合规状况不在本平台控制范围内。您应自行评估经纪商并阅读其服务条款与风险披露。',
      },
      {
        heading: 'RD-07 策略失效与过拟合风险',
        body: '任何量化交易策略（包括 AI 生成的策略）均基于特定历史市场环境设计。市场环境、波动率、相关性结构可能随时间发生根本性变化，导致曾经表现优异的策略在未来失效或产生持续亏损。回测（Backtest）结果存在"过拟合"风险，即策略过度拟合历史数据而在实盘环境中表现不佳。',
      },
      {
        heading: 'RD-08 数据延迟与行情风险',
        body: '本平台展示的行情数据、技术指标和资讯可能存在延迟、错误或不完整。您不应依赖本平台数据作为唯一的交易决策依据；发生相关问题时，我们与您各自依法承担相应责任。',
      },
      {
        heading: 'RD-09 操作与配置风险',
        body: '您选择平台 Agent、提交交易账户资料以及确认、暂停或停止跟随授权，会影响本人账户参与策略执行的范围。请核对账户身份、授权内容及风险偏好；平台侧策略和执行参数由管理侧配置，用户端不创建或配置平台 Agent。',
      },
      {
        heading: 'RD-10 心理依赖与过度交易风险',
        body: '过度依赖 AI 系统的自动化决策可能导致您忽视自身的风险管理责任。AI Agent 在某些市场条件下可能产生高频交易信号，导致过度交易（Over-trading）和交易成本累积。您应定期审查 Agent 的表现，保持对交易活动的主动监控。',
      },
      {
        heading: 'RD-11 交易账户凭据与账户安全风险',
        body: '您提交交易账户资料时，可能需要提供 MT4/MT5 账户登录凭据。托管开通模式下，平台使用受保护的凭据服务管理这些凭据；人工开通模式下，处理方式以提交页面说明为准。凭据泄露可能使交易账户遭到未授权操作。请妥善保管凭据，定期检查账户活动，发现异常及时联系经纪商和平台。',
      },
      {
        heading: 'RD-12 黑天鹅与不可抗力事件',
        body: '战争、恐怖袭击、重大自然灾害、主权债务危机、央行紧急利率调整、交易平台集体宕机等"黑天鹅"事件，可能在极短时间内造成市场剧烈波动和流动性枯竭。在这些极端情况下，任何止损、风控措施都可能失效，您可能遭受超出预期的重大损失。',
      },
      {
        heading: 'RD-13 服务费、费用与资金成本风险',
        body: '交易可能产生经纪商点差、佣金、隔夜利息等成本，这些费用会降低实际净收益。平台如另行收取服务费用，应在启用相应服务前向您说明；本平台不提供充值、提现或结算功能。请结合经纪商账单核对实际成本。',
      },
      {
        heading: 'RD-14 法律合规与地域限制',
        body: '不同国家和地区对外汇保证金交易、差价合约(CFD)、杠杆产品的法律监管要求各不相同。某些司法管辖区可能禁止或限制零售投资者参与此类交易。您有责任确认您所在地区的法律法规，并确保您使用本平台的行为完全符合当地法律要求。如您所在地法律禁止使用本平台服务，请立即停止注册和使用。',
      },
      {
        heading: 'RD-15 平台服务中断与终止风险',
        body: '因系统维护、合规要求或风险控制需要，部分或全部服务可能暂时受限。在服务中断期间，您可能无法访问账户、管理跟随关系或接收决策与执行结果。服务中断不等于经纪商持仓已关闭；请通过经纪商核对实际账户状态。我们将按适用法律处理通知与责任。',
      },
    ],
  },
];
